/**
 * @generated SignedSource<<e20a9eb3c40f11f9b28c6f1ae633e87b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RecurrenceFrequency = "DAILY" | "MONTHLY" | "WEEKLY" | "YEARLY";
export type RoutineIcon = "key" | "residual" | "shelf_hole" | "waste";
import { FragmentRefs } from "relay-runtime";
export type KPIItemTeam_Routine$data = {
  readonly icon: RoutineIcon | null;
  readonly id: string;
  readonly occasions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly endAt: string;
        readonly id: string;
        readonly occasionSections: ReadonlyArray<{
          readonly id: string;
          readonly section: {
            readonly assignedTeam: {
              readonly color: string | null;
              readonly id: string;
            } | null;
            readonly id: string;
          };
          readonly taskExecutions: ReadonlyArray<{
            readonly formattedNumberValue?: string | null;
            readonly goals?: {
              readonly greaterThan: number | null;
              readonly lessThan: number | null;
            } | null;
            readonly id?: string;
            readonly isCompleted?: boolean;
            readonly numberValue?: number | null;
          }>;
        }>;
        readonly sequenceNumber: number;
        readonly startAt: string;
        readonly " $fragmentSpreads": FragmentRefs<"KPIItemTeamInProgress_RoutineOccasion">;
      };
    }>;
  };
  readonly schedule: {
    readonly rules: ReadonlyArray<{
      readonly freq: RecurrenceFrequency;
    }>;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "KPIItemTeam_Routine";
};
export type KPIItemTeam_Routine$key = {
  readonly " $data"?: KPIItemTeam_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIItemTeam_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "teamId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIItemTeam_Routine",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Schedule",
      "kind": "LinkedField",
      "name": "schedule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecurrenceRule",
          "kind": "LinkedField",
          "name": "rules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "freq",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 7
        }
      ],
      "concreteType": "RoutineOccasionConnection",
      "kind": "LinkedField",
      "name": "occasions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineOccasionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineOccasion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sequenceNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endAt",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "KPIItemTeamInProgress_RoutineOccasion"
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "teamId",
                      "variableName": "teamId"
                    }
                  ],
                  "concreteType": "RoutineOccasionSection",
                  "kind": "LinkedField",
                  "name": "occasionSections",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RoutineSection",
                      "kind": "LinkedField",
                      "name": "section",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Team",
                          "kind": "LinkedField",
                          "name": "assignedTeam",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "color",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "taskExecutions",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isCompleted",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "numberValue",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TaskNumberGoals",
                              "kind": "LinkedField",
                              "name": "goals",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "greaterThan",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lessThan",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "formattedNumberValue",
                              "storageKey": null
                            }
                          ],
                          "type": "TaskExecutionNumber",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "occasions(first:7)"
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "e916c52c97c0544bbc12ab8ef7f984fe";

export default node;
